import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosPrivate from 'config/axiosPrivate';

import { ORDERSTATUS } from 'utils/Constants';
import WriterClientProjectTable from 'components/shared/WriterClientProjectTable';
import usePageTracking from 'utils/hooks/usePageTracking';

const WRITER_CLIENT_PROJECTS_DELAYED_PAGE = '/WriterClient/ProjectsEnRetard';

export default function DelayedProject() {
  usePageTracking(WRITER_CLIENT_PROJECTS_DELAYED_PAGE);

  const { t } = useTranslation();

  const [delayedOrders, setDelayedOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));

    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const response = await axiosPrivate.get('/project/by-status');
        if (response.status === 200) {
          const delayed = response.data?.delayedProjects ?? [];
          setDelayedOrders(delayed);
        }
      } catch (error) {
        setIsError(true);
        console.error('Error fetching delayed projects:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <WriterClientProjectTable
      title={t('Projets en retard')}
      orderStatus={ORDERSTATUS.DELAYED}
      orders={delayedOrders}
      isLoading={isLoading}
      isError={isError}
      onRowClickRedirectPath="/WriterClient/DetailsProject"
    />
  );
}


